import { render, staticRenderFns } from "./SettingStatus.vue?vue&type=template&id=87246d9c"
import script from "./SettingStatus.vue?vue&type=script&lang=js"
export * from "./SettingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports